import { clientTranslate } from '@fiverr-private/machine_translation';
import pathfinder from '@fiverr-private/pathfinder';

/**
 * Machine translate the required content
 
 * @param text
 * @param locale
 */
export const machineTranslate = ({ text, targetLocale, sourceInfo }) => {
    const url = pathfinder('logged_out_homepage_ugc_translate');

    return clientTranslate({
        url,
        text,
        targetLocale,
        sourceInfo,
        retry: true,
    });
};
